import { FMSLocationData, FMSSyncedLocationData, SpotData } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Spot/Spot.Controller.ts
export class SpotAPI {
  static async getBrand(brandSlug: string) {
    return APIService.Server.get<SpotData>(`/spot/brand/${brandSlug}`);
  }
  static async getLocation(brandSlug: string, locationSlug: string) {
    return APIService.Server.get<SpotData>(`/spot/brand/${brandSlug}/location/${locationSlug}`);
  }

  static async isBrandSlugUnique(
    orgId: number,
    currentBrandId: number,
    newBrandSlug?: string,
    newShortLink?: string
  ): Promise<{ isUnique: boolean; isInOrg: boolean }> {
    return APIService.Server.get<{ isUnique: boolean; isInOrg: boolean }>(`/spot/org/${orgId}/brand-id/${currentBrandId}/is-unique`, {
      newBrandSlug,
      newShortLink
    });
  }
  static async isLocationSlugUnique(
    orgId: number,
    currentBrandSlug: string,
    currentLocationId: number,
    newLocationSlug?: string,
    newLocationShortLink?: string
  ): Promise<boolean> {
    let payload = {};
    if (newLocationSlug) {
      payload = { newLocationSlug };
    } else if (newLocationShortLink) {
      payload = { newLocationShortLink };
    }

    return APIService.Server.get<boolean>(`/spot/org/${orgId}/brand/${currentBrandSlug}/location-id/${currentLocationId}/is-unique`, payload);
  }
}
